import { render, staticRenderFns } from "./OrderInformation.vue?vue&type=template&id=064f9455&scoped=true&"
import script from "./OrderInformation.vue?vue&type=script&lang=js&"
export * from "./OrderInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrderInformation.vue?vue&type=style&index=0&id=064f9455&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f9455",
  null
  
)

export default component.exports